export interface ApiFailure {
  data?: {
    message?: string
    data?: {
      message?: string
    }
  }
  [key: string]: unknown
}

export const getErrorMessage = (result: ApiFailure | undefined, fallback: string): string =>
  result?.data?.message || result?.data?.data?.message || fallback
